import { transformSharedCount } from './sharedCountTransformer';
import { transformFacebookPage } from './facebookPageTransformer';
import { transformTwitterAccount } from './twitterAccountTransformer';
import { transformInstagramAccount } from './instagramAccountTransformer';
import { transformLinkedinAccount } from './linkedinAccountTransformer';

/**
 * Transforms Social Profiles section criteria from WooRank API response.
 *
 * @param {Object} apiData - full WooRank API response
 * @returns {Object} transformed Social Profiles section data
 */
export const transformSocialProfilesSection = (apiData = {}) => {
  const criteria = apiData?.criteria || {};

  const socialMediaEngagement = transformSharedCount(criteria?.shared_count);
  const facebookPage = transformFacebookPage(criteria?.facebook_brand_page);
  const twitterAccount = transformTwitterAccount(criteria?.twitter_account);
  const instagramAccount = transformInstagramAccount(criteria?.instagram);
  const linkedinAccount = transformLinkedinAccount(criteria?.linkedin);

  const allResults = [
    socialMediaEngagement,
    facebookPage,
    twitterAccount,
    instagramAccount,
    linkedinAccount,
  ];

  const errorCount = allResults.filter((r) => r?.status === 'error').length || 0;
  const toImproveCount = allResults.filter((r) => r?.status === 'warning').length || 0;

  return {
    errorCount,
    toImproveCount,
    socialMediaEngagement,
    facebookPage,
    twitterAccount,
    instagramAccount,
    linkedinAccount,
  };
};

export default transformSocialProfilesSection;


